import {AxiosError} from 'axios';
import {POST_ADMIN_PROFILE_PICTURE_UPLOAD_PRESIGNED_URL} from '../../constants/apiUrls';
import {useCustomMutation} from '../utils/useCustomMutation';
import {PostUploadPresignedUrlRequest, PresignedUrlResponse} from '../../models/PresignedUrl';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PresignedUrlResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostUploadPresignedUrl = ({onSuccess, onError}: Input) => {
  const postUploadPresignedUrl = async (payload: PostUploadPresignedUrlRequest) => {
    const res = await axiosClient.post<PresignedUrlResponse[]>(
        POST_ADMIN_PROFILE_PICTURE_UPLOAD_PRESIGNED_URL,
        [{
          fileName: payload.fileName,
          targetBucket: "APPLICATION"
        }]
    );
    return res.data[0];
  };

  return useCustomMutation(postUploadPresignedUrl, {
    onSuccess,
    onError,
  });
};
